<template>
  <li class="profile-nav onhover-dropdown pe-0 py-0">
    <div class="media profile-media">
      <img height="35" width="35"
        class="b-r-10"
        :src="imageUrl + userImage || '@/assets/images/dashboard/no-user.jpg'"
        alt=""
      />
      <div class="media-body" style="margin-top: 6px;">
        <span class="profile-name">{{ userName }}<i class="middle fa fa-angle-down"></i></span>
        <!-- <p class="mb-0 font-roboto">
          Admin <i class="middle fa fa-angle-down"></i>
        </p> -->
      </div>
    </div>
    <ul class="profile-dropdown onhover-show-div" style="width: 400px;">
     
      <!-- <li>
        <i class="fa fa-gear"></i> <router-link :to="{ name: 'settings' }">Settings</router-link>
      </li> -->
      <li>
        <a @click="logout"
          ><vue-feather type="log-in"></vue-feather><span>Log out</span></a
        >
      </li>
    </ul>
  </li>
</template>

<script setup>
  import { useRouter } from 'vue-router';
  import { routes } from '@/constants/routes';
  import { get } from '@/utils/api';
  import Swal from '@/utils/swal';
  import { onMounted, ref, inject } from 'vue';

  const router = useRouter();
  const imageUrl = inject('imageUrl');
  const userImage = ref('');
  const userName = ref('');

  onMounted(() => {
    settings();
  })

  const logout = () => {

    get(routes.Logout, {}, false)
      .then((response) => {
        if (response.status === 200) {
          if(localStorage.getItem('speed_tech')) {
            localStorage.removeItem("speed_tech");    
          }

          Swal.fire("", response.data.message, "success").then(() => {
            router.push({ name: "login" });
          });
        } else {
          Swal.fire('', response.data.message || 'Failed to fetch jobs', 'error');
        }
      })
      .catch((error) => {
        if (error.response?.status === 422) {
                  Swal.fire('', 'Validation error', 'error');
              } else if (error.response?.status === 500) {
                  Swal.fire('', error.response.statusText || 'Server error', 'error');
              } else if (error.response?.status === 401) {
                  Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                  router.push({ name: 'login' });
              } else {
          Swal.fire('', error.response.data?.message || 'Error occured', 'error');
        }
      });
  };

  const settings = () => {

    get(routes.Settings, { }, false)
    .then((response) => {
      if (response.status === 200) {
        console.log(response.data.data);
        if(response.data.data.name) {
          userName.value = response.data.data.name;
        } else {
          userName.value = response.data.data.user_name;
        }
        userImage.value = response.data.data.profile_img;
      } else {
        Swal.fire('', response.data.message || 'Error fetching data', 'error');
      }
    })
    .catch((error) => {
      if (error.response?.status === 422) {
        Swal.fire('', error.response.data.message || 'Validation error', 'error');
      } else if (error.response?.status === 500) {
        Swal.fire('', error.response.statusText || 'Server error', 'error');
      } else if (error.response?.status === 401) {
        Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
        router.push({ name: 'login' });
      } else {
        Swal.fire('', error.response.data?.message || 'Error occured', 'error');
      }
    });
  };

</script>
